import BaseModel from '../core/BaseModel'
// import gql from 'graphql-tag'
// import graphql from '../views/admin/common/graphql'
import StatusTDModel from './StatusTDModel';
import StatusDocumentModel from './StatusDocumentModel';
import StateModel from './StateModel';
import OfficeAgencyModel from "./OfficeAgencyModel";
export default class ListDocumentModel extends BaseModel {

    constructor() {
        super({ 
                name: "listDoc",
                tableName: 'document', 
                label: "Danh sách tổng hợp văn bản", 
                display_key: 'code_system', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                width: 4,
                class: "center",
                computed: (data) => {
                    data.stt = data.sttKey;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            created_name: {
                name: "created_name", 
                label: "Người tạo",
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.created_name = '';
                    if(data.create_by !== undefined && data.create_by !== null){
                        data.created_name = data.create_by.fullname
                    }
                }
            },
            scan_barcode: {
                name: 'scan_barcode', 
                type: "Boolean",
                label: 'Đã in mã code',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            barcode: {
                name: 'barcode', 
                label: 'Đã in mã code',
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false,
                computed: (data) => {
                    data.barcode = '';
                    if(data.scan_barcode){
                        data.barcode = 1;
                    }
                }
            },
            code_system: {
                name: 'code_system', 
                type: "String",
                label: 'Mã VB hệ thống',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_court: {
                name: 'code_court', 
                type: "String",
                label: 'Mã VB của tòa',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            code_office: {
                name: 'code_office', 
                type: "String",
                label: 'Mã văn phòng',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            number_decision: {
                name: 'number_decision', 
                type: "String",
                label: 'Số quyết định',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            content_document: {
                name: 'content_document', 
                type: "String",
                label: 'Nội dung văn bản',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            date_issued: {
                name: 'date_issued', 
                type: "Date",
                label: 'Ngày ban hành',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_invite: {
                name: 'date_invite', 
                type: "Date",
                label: 'Ngày mời',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            name_litigant: {
                name: 'name_litigant', 
                type: "String", 
                label: 'Tên đương sự', 
                width: 9,
                class: "center",
                sortable: false,
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            },
            address: {
                name: 'address', 
                type: "String",
                label: 'Địa chỉ',
                width: 9,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            ward_ref: { 
                refs: 'ward {id name}',
                display: false
            },
           /* display_ward: {
                name: "display_ward", 
                label: "Phường / Xã",
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_ward = '';
                    if(data.ward !== undefined && data.ward !== null){
                        data.display_ward = data.ward.name;
                    }
                }
            },*/
                id_ward_key: {
                    name: 'id_ward_key', label: 'Phường / Xã', type: "Selection",  dataType: 'Label',  class: 'center', width: 13,
                    options: [],
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    sortable: false,
                    custom: 'SelectionText',
                    computed: (data) => {
                        data.id_ward_key = "";
                    }
                },
            district_ref: { 
                refs: 'district {id name}',
                display: false
            },
            /*display_district: {
                name: "display_district", 
                label: "Quận / Huyện",
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_district = '';
                    if(data.district !== undefined && data.district !== null){
                        data.display_district = data.district.name;
                    }
                }
            },*/
                id_district_key: {
                name: 'id_district_key', label: 'Quận / Huyện', type: "Selection",  dataType: 'Label',  class: 'center', width: 13,
                options: [],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: false,
                custom: 'SelectionText',
                computed: (data) => {
                    data.id_district_key = "";
                }
            },
            state_ref: { 
                refs: 'state {id name}',
                display: false
            },
            /*display_state: {
                name: "display_state", 
                label: 'Tỉnh / Thành phố',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_state = '';
                    if(data.state !== undefined && data.state !== null){
                        data.display_state = data.state.name;
                    }
                }
            },*/
            state_id: {
                name: "state_id",
                label: "Tỉnh / Thành phố",
                width: 13,
                class: "center",
                type: "Selection",
                models: new StateModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            phone_litigant: {
                name: 'phone_litigant',
                type: "String",
                label: 'Số điện thoại',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            signer: {
                name: 'signer', 
                type: "String",
                label: 'Người ký',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            /*code_agency: {
                name: 'code_agency', 
                type: "String",
                label: 'Mã cơ quan',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },*/

            code_agency_tpl: {
                name: "code_agency_tpl",
                label: 'Mã cơ quan',
                class: "center class_code_agency_tpl",
                type: "Selection",
                custom: 'SelectionText',
                width: 8,
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                models: new OfficeAgencyModel(),
                computed: (data) => {
                    data.code_agency_tpl= '';
                }
            },
            date_receipt_court: {
                name: 'date_receipt_court', 
                type: "Date",
                label: 'Ngày nhận VB từ tòa',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_dpv_receipt: {
                name: 'date_dpv_receipt', 
                type: "Date",
                label: 'Ngày ĐPV nhận lại VB',
                width: 13,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            date_request_complete: {
                name: 'date_request_complete', 
                type: "Date",
                label: 'Ngày yêu cầu hoàn thiện lại',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            date_return_court: {
                name: 'date_return_court', 
                type: "Date",
                label: 'Ngày trả tòa',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            type_document: {
                name: 'type_document', 
                type: "Selection",
                label: 'Loại VB',
                width: 6,
                class: "center",
                options: [
                    { value: 1, label: '1', default: true },
                    { value: 2, label: '2'},
                    { value: 3, label: '3'},
                    { value: 4, label: '4'},
                    { value: 5, label: '5'}
                ],
                filter: { 
                    type: 'select', 
                    optionLabel: 'label', 
                    optionKey: 'value', 
                    match: 'equals' 
                },
                // display: false
            },
            cost_document: {
                name: 'cost_document',
                type: "Currency",
                class: "center",
                label: 'Giá VB cơ quan trả',
                filter: { type: 'input', match: 'contains'},
                width: 8,
               // display: false
            },
            is_urgent: {
                name: 'is_urgent', 
                type: "Boolean",
                label: 'VB gấp',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            custom_urgent: {
                name: 'custom_urgent', 
                label: 'VB gấp',
                width: 5,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.custom_urgent = '';
                    if(data.is_urgent){
                        data.custom_urgent = 'Gấp';
                    }
                }
            },
            tdv_ref: { 
                refs: 'tdv {id fullname phone}',
                display: false
            },
            display_tdv: {
                name: 'display_tdv', 
                label: 'Họ & tên TĐV',
                width: 7,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.display_tdv = '';
                    if(data.tdv !== undefined && data.tdv !== null){
                        data.display_tdv = data.tdv.fullname;
                    }
                }
            },
            date_tdv_receipt: {
                name: 'date_tdv_receipt',
                type: "Date",
                label: 'Ngày TĐV nhận VB',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_change_tdv: {
                name: 'date_change_tdv', 
                type: "Date",
                label: 'Ngày đổi TDV',
                width: 13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_tdv_return: {
                name: 'date_tdv_return', 
                type: "Date",
                label: 'Ngày TĐV trả VB',
                width:13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            date_complete: {
                name: 'date_complete',
                type: "Date",
                width:13,
                class: "center",
                label: 'Ngày VB hoàn thành',
                //filter: { type: 'input', match: 'contains'},
                filter: { type: 'DateRange', match: 'custom'},
                //display: false
            },
            vplk_ref: { 
                refs: 'office_vplk {id name code}',
                display: false
            },
            code_vplk: {
                name: 'code_vplk', 
                label: 'Mã VP liên kết',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                computed: (data) => {
                    data.code_vplk = '';
                    if(data.office_vplk !== undefined && data.office_vplk !== null){
                        data.code_vplk = data.office_vplk.code;
                    }
                }
            },
            code_area: {
                name: 'code_area', 
                type: "String",
                label: 'Mã Khu vực',
                width: 6,
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            status_vb_ref: { 
                refs: 'status_document {id name ordinal}',
                display: false
            },
            // status_vb: {
            //     name: "status_vb", 
            //     label: 'Trạng thái VB',
            //     filter: { type: 'input', match: 'contains'},
            //     computed: (data) => {
            //         data.status_vb = '';
            //         if(data.status_document !== undefined && data.status_document !== null){
            //             data.status_vb = data.status_document.name;
            //         }
            //     }
            // },
            status_vb_id: { 
                name: "status_vb_id", 
                label: "Trạng thái VB", 
                width: 8,
                class: "center",
                type: "Selection",
                models: new StatusDocumentModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
            status_td_ref: { 
                refs: 'status_tongdat {id name delay_time}',
                display: false
            },
            // status_td: {
            //     name: "status_td", 
            //     label: 'Hình thức TĐ',
            //     filter: { type: 'input', match: 'contains'},
            //     display: false,
            //     computed: (data) => {
            //         data.status_td = '';
            //         if(data.status_tongdat !== undefined && data.status_tongdat !== null){
            //             data.status_td = data.status_tongdat.name;
            //         }
            //     }
            // },
            status_td_id: { 
                name: "status_td_id", 
                label: "Hình thức TĐ", 
                width: 8,
                class: "center",
                type: "Selection",
                models: new StatusTDModel(),
                filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
            },
                date_month_td: {
                name: 'date_month_td',
                type: "Date",
                label: 'Ngày tháng TĐ',
                width:13,
                class: "center",
                filter: { type: 'DateRange', match: 'custom'},
                // display: false
            },
            total_day_done: {
                name: 'total_day_done',
                label: 'Tổng ngày hoàn thành VB',
                width: 8,
                class: "center",
                filter: { type: 'input', match: 'equals', placeHolder: 'Nhập số ngày', inputType: 'number'},
                computed: (data) => {
                    data.total_day_done = data.total_day_doneKey;
                }
            },
            is_fee_budget: {
                name: 'is_fee_budget', 
                type: "Int",
                label: 'Đối tượng chịu phí',
                filter: { type: 'input', match: 'contains'},
                display: false
            },
            reason_delay: {
                name: 'reason_delay', 
                type: "String",
                label: 'Lý do trễ',
                display: false
            },
            note: {
                name: 'note', 
                type: "String",
                label: 'Ghi chú',
                display: false
            },
            phone_tdv: {
                name: 'phone_tdv', 
                type: "String",
                label: 'SDT TĐV',
                display: false
            },
            is_import: {
                name: 'is_import', 
                type: "Int",
                label: 'Import file',
                display: false
            },
            is_confirmed: {
                name: 'is_confirmed', 
                type: "Checkbox",
                label: 'Xác nhận DPV đưa tay cho TDV',
                display: false
            },
            deadline_color: {
                name: 'deadline_color', 
                type: "Int",
                label: 'Kiểm tra gần hết hạn',
                // filter: { type: 'input', match: 'contains'},
                display: false
            },
            is_late: {
                name: 'is_late', 
                type: "Boolean",
                label: 'Văn bản đã trễ',
                display: false
            },
            created_uid :{
                name: 'created_uid', 
                type: "Uuid",
                label: 'Người tạo',
                display: false
            },
            created_by_ref: { 
                refs: 'create_by {fullname}',
                display: false
            },
                fied_detail: {
                    refs: ' district_id  ward_id code_agency',
                    display: false
                },
        },)
    }

}